<script setup lang="ts">
  import { formatToIndianCurrency } from '~/functions/currencyUtilities';

  const props = defineProps<{
    label: string;
    allocation: number;
    tds: number;
    payable: number;
    // Optional — pages that can't attribute actual payments to a specific bank leave
    // these unset and the column falls back to "-", same as before.
    payments?: number | string;
    viaAdvances?: number | string;
    paid?: number | string;
    balance?: number | string;
  }>();

  const isDash = (value?: number | string) => value === undefined || value === '-';
  const isNegative = (value?: number | string) => !isDash(value) && +value! < 0;
  const isZero = (value?: number | string) => !isDash(value) && !isNegative(value) && +value! === 0;

  const cellText = (value?: number | string) => (isDash(value) ? '-' : formatToIndianCurrency(+value!));
  const cellClass = (value?: number | string) => {
    if (isNegative(value)) return 'text-red-700';
    if (isDash(value)) return 'text-gray-400';
    if (isZero(value)) return 'text-gray-500';
    return 'text-gray-800';
  };
</script>

<template>
  <tr class="bg-gray-50/50 hover:bg-gray-100/70 transition-colors">
    <td class="border border-gray-300 text-gray-600 text-[12px] px-3 py-2 pl-8">{{ props.label }}</td>
    <td :class="`border border-gray-300 text-sm px-3 py-2 text-right ${cellClass(props.allocation)}`">
      {{ formatToIndianCurrency(props.allocation) }}
    </td>
    <td :class="`border border-gray-300 text-sm px-3 py-2 text-right ${cellClass(props.tds)}`">
      {{ formatToIndianCurrency(props.tds) }}
    </td>
    <td :class="`border border-gray-300 text-sm px-3 py-2 text-right ${cellClass(props.payable)}`">
      {{ formatToIndianCurrency(props.payable) }}
    </td>
    <td :class="`border border-gray-300 text-sm px-3 py-2 text-right ${cellClass(props.payments)}`">
      {{ cellText(props.payments) }}
    </td>
    <td :class="`border border-gray-300 text-sm px-3 py-2 text-right ${cellClass(props.viaAdvances)}`">
      {{ cellText(props.viaAdvances) }}
    </td>
    <td :class="`border border-gray-300 text-sm px-3 py-2 text-right ${cellClass(props.paid)}`">
      {{ cellText(props.paid) }}
    </td>
    <td :class="`border border-gray-300 text-sm px-3 py-2 text-right ${cellClass(props.balance)}`">
      {{ cellText(props.balance) }}
    </td>
  </tr>
</template>
